export type KeyValuePair<K, V> = {
  key: K;
  value: V;
};
